import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import Modal from 'react-modal';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { GameController } from '@mental-mint/shared-ui/GameController/GameController';
import { Game } from '@mental-mint/shared-ui/Store/gameSessionSlice';
import { ErrorBoundary } from '@mental-mint/shared-ui';
import { GameId } from '@mental-mint/shared-types';
import { 
  initializeAnalytics,
  initializeGrowthBook,
  logger,
  getGrowthBook
} from '@mental-mint/shared-utils';
import { store } from './store';
import { getWordDriftGame } from './GameSettings';
import ClipLoader from 'react-spinners/ClipLoader';
import './index.css';

// Configure react-modal for accessibility
Modal.setAppElement('#root');

initializeAnalytics(GameId.Taptionary);

// Initialize GrowthBook early to ensure features load before components need them
initializeGrowthBook();

/**
 * App wrapper component
 */
function App() {
  const [gameConfig, setGameConfig] = useState<Game | null>(null);

  // Load game configuration with initial modal determined dynamically
  useEffect(() => {
    const loadGameConfig = async () => {
      const config = await getWordDriftGame();
      setGameConfig(config);
    };
    loadGameConfig();
  }, []);

  // Show loading state while game config loads
  if (!gameConfig) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100dvh',
        backgroundColor: '#1a1a1a'
      }}>
        <ClipLoader size={50} color={"white"} />
      </div>
    );
  }

  return (
    <GameController 
      gameId={GameId.Taptionary} 
      game={gameConfig}
    />
  );
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <GrowthBookProvider growthbook={getGrowthBook()}>
        <Provider store={store}>
          <App />
        </Provider>
      </GrowthBookProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
